export default "__VITE_ASSET__DvTaYPX3__"